import { RemoveConditions, RemoveOption } from "@components/table/members/bulk-actions/bulk-remove-member-types";

/**
 * Builds available remove options based on user permissions
 * @param conditions The permission conditions for each remove action
 * @returns Array of available remove options
 */
export function buildAvailableRemoveOptions(
  conditions: RemoveConditions
): RemoveOption[] {
  const options: RemoveOption[] = [];

  if (conditions.canRemoveFromTeam) {
    options.push({
      key: "team",
      label: "Remove from team",
      subjectType: "team",
    });
  }

  if (conditions.canRemoveFromWorkspace) {
    options.push({
      key: "workspace",
      label: "Remove from Workspace",
      subjectType: "workspaceTeam",
    });
  }

  return options;
}
